import { NgModule } from '@angular/core'
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome'
import { faTrash, faPlus, faEdit } from '@fortawesome/free-solid-svg-icons'

@NgModule({
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule],
})
export class GlobalFontAwesomeModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faTrash, faPlus, faEdit)
  }
}
